export const CallIcon = () => {
  return (
    <svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_190_4514)'>
        <path
          d='M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z'
          fill='#FFCD4B'
        />
        <path
          d='M35.5437 21.0161L32.4812 17.9536L10.5 41.3984L24.9338 55.8322C25.9409 55.9419 26.9637 56 28 56C43.464 56 56 43.464 56 28C56 27.5681 55.9887 27.1387 55.9694 26.7116L43.8594 14.6016L35.5437 21.0161Z'
          fill='#FFAA00'
        />
        <path
          d='M12.1406 14.6016V37.5703L28 39.4844L30.5027 26.2137L28 14.6016H12.1406Z'
          fill='#555A65'
        />
        <path d='M43.8594 14.6016H28V39.4844L43.8594 37.5703V14.6016Z' fill='#333940' />
        <path d='M14.3281 16.7891V35.3828H28L29.7224 26.0859L28 16.7891H14.3281Z' fill='white' />
        <path d='M28 16.7891H41.6719V35.3828H28V16.7891Z' fill='#E9EDF5' />
        <path
          d='M10.5 37.5703V41.3984H28L28.8299 39.4844L28 38.069L24.1719 37.5703H10.5Z'
          fill='#333940'
        />
        <path d='M45.5 37.5703V41.3984H28V38.069L31.8281 37.5703H45.5Z' fill='#101214' />
        <path d='M24.1719 37.5703V39.4844H28L28.4822 38.5273L28 37.5703H24.1719Z' fill='white' />
        <path d='M28 37.5703H31.8281V39.4844H28V37.5703Z' fill='#E9EDF5' />
      </g>
      <defs>
        <clipPath id='clip0_190_4514'>
          <rect width='56' height='56' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
